import { axiosInstance, getRequest } from "./apiService";

export const getVideos = () => {
    return getRequest("/videos").then((response) => response.data);
}